import { getRoot } from 'mobx-easy';
import RootStore from 'bringg-web/stores/root-store';

async function load(taskIds: number[]) {
	const { tasksStore, runStore, plannedRoutesStore } = getRoot<RootStore>().data;

	const runIds = taskIds.reduce((acc, id) => {
		const relatedTask = tasksStore.get(id);

		if (relatedTask?.run_id) {
			acc.push(relatedTask.run_id);
		}

		return acc;
	}, []);

	const runs = await runStore.loadAllByIds(Array.from(new Set(runIds.map(id => id))));

	const teamIds = Array.from(new Set(runs.map(run => run.team_id)));
	plannedRoutesStore.setBatch(await plannedRoutesStore.getAllByTeams(teamIds));
}

export const alertRunsProvider = { load };
